import React,{useEffect,useState,Fragment} from 'react';
import {useHistory,Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import styled from 'styled-components';
import Panel from '../components/Panel';
import Content from '../components/Content';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'


const Home = () => {

    const [q1,getQ1] = useState();
    const [isAnswered,setIsAnswered] = useState(false);
    const history = useHistory();
    const [isExtraOpen, setIsExtraOpen] = useState(false);

    const getInput = e => {
        const t = e.currentTarget.value;
        getQ1(t);
    }

    const checkInput = e => {
        setIsAnswered(true)
        e.preventDefault();
    }

    return(
        <HomePage>
            <Panel w={50} setBG="home">
                <SlideTitle>how do your <em>business processes</em> stack up <br /> against the competition?</SlideTitle>
            </Panel>
            <Content noTab>
                <h2 className="question-title"><b>Customer demands</b> are becoming more complex</h2>
                <p>To stay ahead of your competition, you need to ensure your <b>business processes</b> are operating at optimal <b>efficiency</b> and <b>efficacy</b>.</p>
                <p>Take our quick <b>business process assessment</b>, with <b>tips</b> and <b>best practices</b> that can help you <b>optimize</b> your most strategic business processes.</p>
                <p className="small-bold"><em>Are you ready?</em></p>
                <Link style={{textDecoration: 'none'}} to="/question1">
                    <StartButton>let’s get started! <Ar icon={faArrowRight}/></StartButton>
                </Link>
            </Content>
           
    
        </HomePage>
    )
}

const HomePage = styled(motion.div)`
    width: 100%;
    height: 100%;
    overflow-x: hidden !important;
    display: flex;

    @media (max-width: 1060px) {
    flex-direction: column;
}
    
`;

const SlideTitle = styled.h1`
    font-family: 'MarkPro-Black';
    font-size: 3.5em;
    max-width: 60%;
    text-align: right;
    margin-left: auto;
    position: relative;
    left: 50px;
    z-index: 10;
    

    br{
        display: none;
    }

    @media (max-width: 1060px) {
           font-size: 1.8em;
           left: 20px;
           top: 30px;
           /* max-width: 70%; */
           text-align: left;
           margin-left: unset;
           max-width: unset;

           br{
               display: block;
           }
        }
`;

const StartButton = styled.div`
    font-family: 'MarkPro-Black';
    color: #fff;
    background: #EAB330;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 2em;
    padding: 15px;
    cursor: pointer;

    @media (max-width: 1060px) {
        position: static;
        margin-top: 20px;
    }
`;


const Ar = styled(FontAwesomeIcon)`
    color: #333147;
    fill: #333147;
    margin-left: 20px;
`;

export default Home;